// some actual JavaScript is needed so this file gets picked up in compilation lol
export function isSpaRouter(rawInput) {
    if (typeof rawInput !== 'object' || !rawInput) {
        return false;
    }
    const propsToCheck = {
        setRoutes: 'function',
        createRoutesUrl: 'function',
        addRouteListener: 'function',
        hasRouteListener: 'function',
        getCurrentRawRoutes: 'function',
        listeners: 'object',
        sanitizationDepth: 'number',
        sanitizeFullRoute: 'function',
        removeRouteListener: 'function',
        initParams: 'object',
    };
    const input = rawInput;
    const missingProperties = Object.keys(propsToCheck).filter((key) => {
        if (!input.hasOwnProperty(key) || !(typeof input[key] !== propsToCheck[key])) {
            return true;
        }
        return false;
    });
    return !missingProperties.length;
}
